"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimTableResponseToJSONTyped = exports.SimTableResponseToJSON = exports.SimTableResponseFromJSONTyped = exports.SimTableResponseFromJSON = exports.instanceOfSimTableResponse = void 0;
/**
 * Check if a given object implements the SimTableResponse interface.
 */
function instanceOfSimTableResponse(value) {
    return true;
}
exports.instanceOfSimTableResponse = instanceOfSimTableResponse;
function SimTableResponseFromJSON(json) {
    return SimTableResponseFromJSONTyped(json, false);
}
exports.SimTableResponseFromJSON = SimTableResponseFromJSON;
function SimTableResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'maxFlowDam': json['max_flow_dam'] == null ? undefined : json['max_flow_dam'],
        'maxFlowNodam': json['max_flow_nodam'] == null ? undefined : json['max_flow_nodam'],
        'maxWlevelDam': json['max_wlevel_dam'] == null ? undefined : json['max_wlevel_dam'],
        'maxWlevelNodam': json['max_wlevel_nodam'] == null ? undefined : json['max_wlevel_nodam'],
        'floodControlEffectFlow': json['flood_control_effect_flow'] == null ? undefined : json['flood_control_effect_flow'],
        'floodControlEffectWlevel': json['flood_control_effect_wlevel'] == null ? undefined : json['flood_control_effect_wlevel'],
    };
}
exports.SimTableResponseFromJSONTyped = SimTableResponseFromJSONTyped;
function SimTableResponseToJSON(json) {
    return SimTableResponseToJSONTyped(json, false);
}
exports.SimTableResponseToJSON = SimTableResponseToJSON;
function SimTableResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'max_flow_dam': value['maxFlowDam'],
        'max_flow_nodam': value['maxFlowNodam'],
        'max_wlevel_dam': value['maxWlevelDam'],
        'max_wlevel_nodam': value['maxWlevelNodam'],
        'flood_control_effect_flow': value['floodControlEffectFlow'],
        'flood_control_effect_wlevel': value['floodControlEffectWlevel'],
    };
}
exports.SimTableResponseToJSONTyped = SimTableResponseToJSONTyped;
